// extracted by mini-css-extract-plugin
export var orderDetails = "_s7-2";
export var orderImage = "_s7-1";
export var orderMeta = "_s7-3";
export var orderSummary = "_s7-0";
export var rightArrow = "_s7-4";